import React from 'react';

import get from 'lodash/get';
import { NotBitbucketStaffError } from '../not-bitbucket-staff';
import { ServerError } from '../server-error';
import './error.scss';

const typeToComponentMap = {
  'not-bitbucket-staff': NotBitbucketStaffError,
};

interface Props {
  match: {
    params: {
      errorType: string | null;
    };
  };
}

export const KnownServerError = (props: Props) => {
  const errorType = get(props, 'match.params.errorType');
  const ErrorComponent = get(typeToComponentMap, errorType, ServerError);

  return (
    <div className="error-flag">
      <ErrorComponent {...props} />
    </div>
  );
};
